module.exports = __webpack_public_path__ + "img/logo_SGR.0db114da.jpeg";